import { z } from 'zod';
import type { Zoom } from './scale';

/**
 * URL state of the Gantt: zoom level, row order, the task in the side panel and a template to
 * apply (set after „Projekt anlegen“ with a template, PROJ-07).
 */
export type GanttSearch = { zoom?: Zoom; sort?: 'start'; task?: string; apply?: string };

const schema = z.object({
  zoom: z.enum(['day', 'week', 'month', 'quarter']).optional().catch(undefined),
  sort: z.literal('start').optional().catch(undefined),
  task: z.string().max(20).optional().catch(undefined),
  apply: z.uuid().optional().catch(undefined),
});

export function parseGanttSearch(raw: Record<string, unknown>): GanttSearch {
  const parsed = schema.parse(raw);
  const search: GanttSearch = {};
  if (parsed.zoom !== undefined) search.zoom = parsed.zoom;
  if (parsed.sort !== undefined) search.sort = parsed.sort;
  if (parsed.task !== undefined) search.task = parsed.task;
  if (parsed.apply !== undefined) search.apply = parsed.apply;
  return search;
}

export function withGanttTask(search: GanttSearch, key: string | undefined): GanttSearch {
  const next = { ...search };
  if (key === undefined) delete next.task;
  else next.task = key;
  return next;
}
